import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import PresetCard, { PresetCardSkeleton } from '../PresetCard'
import type { DynamicPagePresetData } from '@/modules/client-setting/type'

interface PresetGalleryProps {
	data: DynamicPagePresetData[]
	isLoading?: boolean
}

export default function PresetGallery({ data, isLoading }: PresetGalleryProps) {
	return (
		<div className="space-y-4">
			<Heading
				title="เทมเพลตหน้าเว็บ"
				description="เลือกเทมเพลตเพื่อสร้างหน้าเว็บสำเร็จรูป แล้วปรับแต่งเพิ่มเติมได้ตามต้องการ"
			/>
			<Separator />

			{isLoading ? (
				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{Array.from({ length: 6 }).map((_, i) => (
						<PresetCardSkeleton key={i} />
					))}
				</div>
			) : data.length === 0 ? (
				<div className="flex h-32 items-center justify-center">
					<p className="text-muted-foreground">ไม่พบเทมเพลต</p>
				</div>
			) : (
				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{data.map((preset) => (
						<PresetCard key={preset.id} preset={preset} />
					))}
				</div>
			)}
		</div>
	)
}
